import {Input, Stack} from '@mui/material';
import React from 'react';

export const PinInput: React.FC<{
  value: string[] | undefined;
  visible: boolean;
  length?: number;
  spacing?: number;
  size?: number;
  onChange?: (value: string[]) => void;
}> = ({value, visible, onChange, length = 4, spacing = 4, size = 64}) => {
  const handlePaste = (e: React.ClipboardEvent) => {
    e.preventDefault();
    const digits = e.clipboardData
      .getData('text')
      .replace(/\D/g, '')
      .split('')
      .slice(0, length);
    if (digits.length) onChange?.(digits);
  };

  return (
    <Stack
      direction="row"
      spacing={spacing}
      justifyContent="center"
      onPaste={handlePaste}>
      {Array.from({length}).map((_, index) => {
        return (
          <PinInputField
            key={`pin-${index}`}
            index={index}
            total={length}
            size={size}
            value={value?.[index] ?? ''}
            visible={visible}
            onChange={(e) => {
              const next = [...(value ?? [])];
              next[index] = e;
              onChange?.(next);
            }}
          />
        );
      })}
    </Stack>
  );
};

const PinInputField: React.FC<{
  index: number;
  total: number;
  size: number;
  value: string | undefined;
  onChange?: (value: string, index: number) => void;
  visible: boolean;
}> = ({index, total, size, value, onChange, visible}) => {
  return (
    <Input
      id={`pin-input-${index}`}
      type={visible ? 'text' : 'password'}
      disabled={!onChange}
      inputMode="numeric"
      inputProps={{
        'aria-label': `Digit ${index + 1}`,
        sx: {
          textAlign: 'center',
        },
      }}
      sx={(theme) => ({
        border: 1,
        borderColor: theme.palette.grey['500'],
        borderRadius: '16px',
        width: size,
        height: size,
        fontSize: theme.typography.h4.fontSize,
        caretColor: 'transparent',
      })}
      value={value}
      onChange={(e) => {
        const eventValue = e.target.value;
        const digit = convertToDigit(value, eventValue);
        onChange?.(digit, index);
        // focus next input
        if (digit && index < total - 1) {
          document.getElementById(`pin-input-${index + 1}`)?.focus();
        } else if (digit && index === total - 1) {
          setTimeout(() => {
            document.getElementById('pin-announcement')?.focus();
          }, 2000);
        }
      }}
      onKeyDown={(e) => {
        if (e.key === 'Backspace' && value === '' && index > 0) {
          document.getElementById(`pin-input-${index - 1}`)?.focus();
        }
      }}
    />
  );
};

const convertToDigit = (current: string | undefined, event: string) => {
  if (!current) return event;
  if (!event) return '';
  if (current[0] === event[0]) return event[1];
  return event;
};
